// react
import React from 'react';

// components
import DatePickerWrapper from './DatePickerWrapper/DatePickerWrapper';
import Skeletonize from '../Skeletons/Skeletonize';

// utils
import * as translator from '../utils/translator';

type Props = {
	onDateSelection: (date: string) => void;
	activeDates?: string[];
	selectedDate: string | null;
	additionalClassName?: string;
	language?: string;
	isLoading?: boolean;
}

const SelectDateCalander: React.FC<Props> = ({ onDateSelection, activeDates, selectedDate, additionalClassName, language="de", isLoading=false }) => {
	// Function to determine if a date is available or not
	const getDayClassName = (date: Date): string | undefined => {
		// Use local timezone date formatting to avoid timezone issues
		// This is simpler and more reliable than using Intl.DateTimeFormat with UTC
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		const dateString = `${year}-${month}-${day}`;
		
		
		// Check if activeDates is provided and if the current date is in the available dates
		if (activeDates && activeDates.length > 0 && activeDates.includes(dateString)) {
			return "date-available"; // Active dates get black text
		}
		
		// All other dates (past, present, future) get gray text
		return "date-inactive pointer-events-none";
	}

	return (
		<div
			id="select-date-calander-container"
			className={`
        	    rounded-[16px]
				bg-[#ffffff]
				h-fit
				px-5 lg:px-8
				py-4 lg:py-9
				custom-scrollbar
				${additionalClassName}
			`}
		>
			<Skeletonize
				isLoading={isLoading}
				className='h-[24px] md:h-[26px] mb-[8px] md:mb-[6px]'
				animation='syncWave pulse'
			>
				<h3
					id="doctor-available-times-title"
					className="
						leading-[1.3]
						text-[21px] lg:text-[23px]  
						font-medium
						text-[#000000]
						first-letter:uppercase
						pb-0
						animate-fade-in-up-10
					"
				>
					{translator.translate(language, "default", "schedule_video_consultation/select_date")}
				</h3>
			</Skeletonize>	

			<Skeletonize
				isLoading={isLoading}
				className='h-[15px] mb-[25px] md:mb-[40px]'
				animation='syncWave pulse'
			>
				<h5
					id="doctor-available-times-subtitle"
					className="
						font-normal
						first-letter:uppercase
						font-roboto
						text-[#4B5B4B]
						text-[13px] md:text-[14px] lg:text-[15px]
						pb-0
						animate-fade-in-up-10
					"
				>
					{translator.translate(language, "default", "schedule_video_consultation/choose_your_preferred_appointment_date")}
				</h5>
			</Skeletonize>

			<div className="mt-[25px] md:mt-[40px]">
			<Skeletonize
				isLoading={isLoading}
				className='w-full aspect-square'
				animation='syncWave pulse'
			>
				<DatePickerWrapper 
					onChange={onDateSelection}
					errorMode={false}
					value={selectedDate || ''}
					isBirthdayInput={false}
					inline={true}
					customDayClassName={getDayClassName}
					variant="appointment"
				/>
			</Skeletonize>
			</div>
		</div>
	);
}

export default SelectDateCalander;